import { Injectable } from '@angular/core';
import { AuthData } from '../model/session';
import { AUTH_STORAGE_KEY } from 'src/app/core/constant/constants';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  constructor(private router: Router) {}

  setAuth(auth: AuthData): void {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(auth));
  }

  getAuth(): AuthData | null {
    const data = localStorage.getItem(AUTH_STORAGE_KEY);
    return data ? (JSON.parse(data) as AuthData) : null;
  }

  getToken(): string | null {
    return this.getAuth()?.token ?? null;
  }

  getRefreshToken(): string | null {
    return this.getAuth()?.refreshToken ?? null;
  }

  clear(): void {
    localStorage.removeItem(AUTH_STORAGE_KEY);
    this.router.navigate(['/']).then(() => window.location.reload());
  }
}
